import React from 'react';

import { ShapeProps } from '../XYChart';
import { LineShape } from './LineShape';

export const lineShapeRenderer = (props: ShapeProps): JSX.Element => {
  return <LineShape {...props} />;
};
